import { render, staticRenderFns } from "./MyInputVideo.vue?vue&type=template&id=6cd6b244&scoped=true&"
import script from "./MyInputVideo.vue?vue&type=script&lang=js&"
export * from "./MyInputVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd6b244",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cd6b244')) {
      api.createRecord('6cd6b244', component.options)
    } else {
      api.reload('6cd6b244', component.options)
    }
    module.hot.accept("./MyInputVideo.vue?vue&type=template&id=6cd6b244&scoped=true&", function () {
      api.rerender('6cd6b244', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyInputVideo.vue"
export default component.exports